module.exports = __webpack_public_path__ + "img/call.489f487e.png";